<script type="text/javascript">
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
  },
};
</script>

<template>
  <div class="preview-carousel-loader">
    <div class="preview-carousel-loader__nav">
      <div
        class="preview-carousel-loader__nav-item preview-carousel-loader__nav-item--active"
      ></div>
      <div class="preview-carousel-loader__nav-item"></div>
      <div class="preview-carousel-loader__nav-item"></div>
      <div class="preview-carousel-loader__nav-item"></div>
      <div class="preview-carousel-loader__nav-item"></div>
    </div>
    <div class="preview-carousel-loader__content">
      <div class="preview-carousel-loader__story">
        <div class="preview-carousel-loader__title"></div>
        <template v-if="isLayoutMobile">
          <div class="preview-carousel-loader__media"></div>
          <div class="preview-carousel-loader__copy">
            <div
              class="preview-carousel-loader__copy-line preview-carousel-loader__copy-line--wide"
            ></div>
            <div class="preview-carousel-loader__copy-line"></div>
            <div class="preview-carousel-loader__copy-line"></div>
            <div class="preview-carousel-loader__copy-line"></div>
            <div class="preview-carousel-loader__copy-line"></div>
            <div
              class="preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"
            ></div>
          </div>
        </template>
        <div v-else class="preview-carousel-loader__main">
          <div class="preview-carousel-loader__media-column">
            <div class="preview-carousel-loader__media"></div>
          </div>
          <div class="preview-carousel-loader__copy-column">
            <div class="preview-carousel-loader__copy">
              <div
                class="preview-carousel-loader__copy-line preview-carousel-loader__copy-line--wide"
              ></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div
                class="preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"
              ></div>
            </div>
            <div class="preview-carousel-loader__copy-secondary">
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div class="preview-carousel-loader__copy-line"></div>
              <div
                class="preview-carousel-loader__copy-line preview-carousel-loader__copy-line--short"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.preview-carousel-loader {
  @import '~styles/settings';

  $preview-carousel-loader-color: rgba(103, 153, 159, 0.3);
  $preview-carousel-loader-animation: preview-carousel-loader-pulse 2.2s ease-in-out infinite;

  display: flex;
  flex-direction: column;
  background: white;
  min-height: 540px;

  body[data-theme='dark'] & {
    background: var(--surface-panel);
  }

  &__nav {
    position: relative;
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
    min-height: 41px;
    margin-bottom: 28px;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 1px;
      background: $preview-carousel-loader-color;
      animation: $preview-carousel-loader-animation;

      body[data-theme='dark'] & {
        background: var(--skeleton-base);
      }
    }
  }

  &__nav-item {
    flex: 0 0 74px;
    border-radius: 999px;

    @include text-line(74px, 14px);
    animation: $preview-carousel-loader-animation;

    &--active {
      flex-basis: 92px;
    }
  }

  &__content {
    width: 100%;
    height: 475px;
  }

  &__story {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 475px;
  }

  &__title {
    margin-bottom: 20px;

    @include text-line(42%, 28px);
    animation: $preview-carousel-loader-animation;
  }

  &__main {
    display: flex;
    gap: 20px;
    align-items: stretch;
    flex: 1 1 auto;
  }

  &__media-column {
    display: flex;
    flex-direction: column;
    flex: 0 0 calc(48% - 10px);
  }

  &__copy-column {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-self: stretch;
  }

  &__media {
    width: 100%;
    border-radius: 4px;

    @include text-line(100%, 372px);
    animation: $preview-carousel-loader-animation;
  }

  &__copy {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin-top: 2px;
  }

  &__copy-line {
    @include text-line(100%, 14px);
    animation: $preview-carousel-loader-animation;

    &--wide {
      width: 96%;
    }

    &--short {
      width: 72%;
    }
  }

  &__copy-secondary {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 28px;
    width: 100%;
  }

  @include breakpoint(small down) {
    min-height: 520px;

    &__nav {
      gap: 12px;
      min-height: 30px;
    }

    &__nav-item {
      flex-basis: 60px;
    }

    &__content,
    &__story {
      height: 458px;
    }

    &__title {
      width: 72%;
      margin-bottom: 16px;
    }

    &__media {
      margin-bottom: 16px;
    }
  }
}

@keyframes preview-carousel-loader-pulse {
  0%,
  100% {
    opacity: 0.7;
  }

  50% {
    opacity: 0.25;
  }
}
</style>
